import React from 'react';
import ReactExport from 'react-data-export';
import IconConvertToExcel from '../../../../assets/images/IconConvertToExcel.png';
import { IconButton, Tooltip } from '@material-ui/core';
import { storageFechaFija, storageMonedaSigno } from '../../../../shared/sessionData';
import { formatNumber } from '../../../../shared/formatNumber';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const TablaComparacionVentasEntreSucursalesToExcel = (props) => {
  const headersStyle = {
    font: { sz: '12', bold: true },
    fill: { fgColor: { rgb: 'FFD3D3D3' } },
    alignment: { horizontal: 'center' }
  };

  const cellsStyleVerifNegative = (value, isTotal) => {
    return {
      font: { sz: '10', bold: false, color: { rgb: value < 0 && 'FFFF0000' } },
      alignment: { horizontal: 'right' },
      fill: isTotal && { fgColor: { rgb: 'FFD3D3D3' } }
    };
  };

  const formatData = () => {
    var sumMonto1 = 0;
    var sumMonto2 = 0;
    var sumDifMontos = 0;
    var formatData = [];
    props.ventas.map((venta) => {
      sumMonto1 = sumMonto1 += venta.monto1;
      sumMonto2 = sumMonto2 += venta.monto2;
      sumDifMontos = sumDifMontos += venta.difMontos;
      const inTotal = !venta.id;
      return formatData.push([
        {
          value: venta.nombre,
          style: { font: { sz: '10', bold: inTotal }, fill: inTotal && { fgColor: { rgb: 'FFD3D3D3' } } }
        },
        {
          value: `${storageMonedaSigno()} ${formatNumber(venta.monto1)}`,
          style: cellsStyleVerifNegative(venta.monto1, inTotal)
        },
        {
          value: inTotal ? '-' : `${formatNumber(venta.porcParticipacion1)} %`,
          style: cellsStyleVerifNegative(venta.porcParticipacion1, inTotal)
        },
        {
          value: `${storageMonedaSigno()} ${formatNumber(venta.monto2)}`,
          style: cellsStyleVerifNegative(venta.monto2, inTotal)
        },
        {
          value: inTotal ? '-' : `${formatNumber(venta.porcParticipacion2)} %`,
          style: cellsStyleVerifNegative(venta.porcParticipacion2, inTotal)
        },
        {
          value: `${storageMonedaSigno()} ${formatNumber(venta.difMontos)}`,
          style: cellsStyleVerifNegative(venta.difMontos, inTotal)
        },
        {
          value: `${formatNumber(venta.porcComparacion)} %`,
          style: cellsStyleVerifNegative(venta.porcComparacion, inTotal)
        }
      ]);
    });

    return formatData;
  };

  const multiDataSet = [
    {
      xSteps: 1,
      columns: [
        { title: props.sucursales[0].nombre },
        { title: '' /*style: { border: { right: { style: 'thick', color: 'FF000000' } } }*/ },
        { title: props.sucursales[1].nombre },
        { title: '' }
      ],
      data: []
    },
    {
      columns: [
        {
          title: props.ventasPor,
          width: { wch: 40 },
          style: {
            font: { sz: '12', bold: true },
            fill: { fgColor: { rgb: 'FFD3D3D3' } }
          }
        },
        {
          title: `Monto`,
          width: { wpx: 100 },
          style: headersStyle
        },
        { title: `Porc. Participación`, width: { wpx: 150 }, style: headersStyle },
        {
          title: `Monto`,
          width: { wpx: 100 },
          style: headersStyle
        }, //char width
        { title: `Porc. Participación`, width: { wpx: 150 }, style: headersStyle },
        { title: `Dif. Montos`, width: { wpx: 100 }, style: headersStyle },
        { title: `Porc. Comparación`, width: { wpx: 150 }, style: headersStyle }
      ],
      data: formatData()
    }
  ];

  return (
    <ExcelFile
      filename={`Analisis por ${props.ventasPor.toLowerCase()} al ${storageFechaFija()}`}
      element={
        <Tooltip title="Descargar en excel">
          <IconButton style={{ marginRight: '10px' }} size="small">
            <img alt="" src={IconConvertToExcel} height={'33px'} />
          </IconButton>
        </Tooltip>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name={`Análisis por ${props.ventasPor.toLowerCase()}`} />
    </ExcelFile>
  );
};

export default TablaComparacionVentasEntreSucursalesToExcel;
